import {AlertTriangle} from "lucide-react";
import {useLocation} from "react-router-dom";
import {useShopSite} from "./ShopSiteProvider";
import {PUBLIC_PATHS} from "@/lib/paths";

export function ShopMaintenanceBanner() {
  const {status, ready} = useShopSite();
  const {pathname} = useLocation();
  if(!ready || status.shopEnabled) return null;
  if(pathname.startsWith("/vadmin")) return null;
  if(PUBLIC_PATHS.includes(pathname as typeof PUBLIC_PATHS[number]) && pathname !== "/") return null;
  return (
    <div className="cc-shop-closed border-b border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-950">
      <div className="inside flex items-start gap-2">
        <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
        <p>{status.closedMessage}</p>
      </div>
    </div>
  );
}
